import { BaseAnalyticsEvent, TrackEventParams } from "./types";
import { sendToYandexMetrika } from "./providers/yandexMetrika";
import { sendToRoistat } from "./providers/roistat";
import { getTypeQuestionnaires, sanitizeObject } from "~/utils";
import { COUNTER_ID_YMETRIKA } from "~/configs/consts";

export function trackEvent(params: TrackEventParams) {
	const event: BaseAnalyticsEvent = sanitizeObject({
		orgType: params.orgType,
		appVersion: params.appVersion,
		eventName: params.eventName,
		extra: params.extra || {},
		typeQuestionnaire: params.typeQuestionnaire || getTypeQuestionnaires(),
	});

	if (params.config.isDev) return;

	const shouldSendToYandex = params.config.enabled.yandex &&
		(!params.providers || params.providers.includes('yandex'));

	const shouldSendToRoistat = params.config.enabled.roistat &&
		(!params.providers || params.providers.includes('roistat'));

	if (shouldSendToYandex) {
		sendToYandexMetrika(COUNTER_ID_YMETRIKA, event);
	}

	if (shouldSendToRoistat) {
		sendToRoistat(event);
	}
}
